import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_morges-ramen/artifacts/b8jd0rbw_Logo%20Hanamiya.jpg";

export default function PageTransition() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) { first.current = false; return; }
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 600);
    return () => clearTimeout(t);
  }, [pathname]);

  if (!visible) return null;
  return (
    <div
      data-testid="page-transition"
      className="fixed inset-0 z-[200] bg-background flex items-center justify-center pointer-events-none"
      style={{ animation: "fadeOutOverlay 600ms ease forwards" }}
    >
      <div className="flex flex-col items-center gap-6">
        <div className="relative">
          <img
            src={LOGO_URL}
            alt="Hanamiya"
            className="w-24 h-24 rounded-full object-cover"
            style={{ animation: "logoPulse 600ms ease-in-out" }}
          />
          <div className="absolute inset-0 rounded-full border-2 border-primary border-t-transparent animate-spin" style={{ animationDuration: "0.6s" }} />
        </div>
        <span className="font-display text-primary text-lg tracking-wide">Hanamiya</span>
      </div>
      <style>{`
        @keyframes fadeOutOverlay {
          0%, 60% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes logoPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
      `}</style>
    </div>
  );
}
